import { getEnvironmentInfo } from "shared/utils/config";
import { AppType, LocalStorageKey } from "shared/utils/enums";
import { JsonStorage } from "shared/utils/storage/JsonStorage";
import { TableStateCustom } from "./table.types";

export class TableStorage {
  static getTableState(key: string) {
    if (getEnvironmentInfo().appType === AppType.CONSOLE) {
      const allTableStates = JsonStorage.getData(LocalStorageKey.TABLE_STATE);
      return allTableStates[key] || {};
    } else {
      return {};
    }
  }

  static setTableState(key: string, data: TableStateCustom) {
    try {
      if (getEnvironmentInfo().appType === AppType.CONSOLE) {
        const allTableStates = JsonStorage.getData(LocalStorageKey.TABLE_STATE);
        allTableStates[key] = data;
        JsonStorage.setData(LocalStorageKey.TABLE_STATE, allTableStates);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
